import { IconComponent } from './types';

const TeamIcon: IconComponent = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M10.577 4.667a1.248 1.248 0 1 1-2.494 0 1.248 1.248 0 1 1 2.494 0Zm-4.666 0a1.248 1.248 0 1 1-2.494 0 1.248 1.248 0 1 1 2.494 0ZM1.083 9.625c0-.156.074-.33.286-.525.215-.198.537-.383.932-.541.79-.316 1.748-.475 2.365-.475.617 0 1.575.159 2.366.475.395.158.717.343.932.541.211.196.286.37.286.525v.959H1.083v-.959Zm9.333 0a2.67 2.67 0 0 0-.452-1.499c.543.067 1.18.211 1.735.433.395.158.716.343.931.541.212.196.286.37.286.525v.959h-2.5v-.959Z"
        stroke="#000"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default TeamIcon;
